<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        应急车辆信息
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="表格列设置"
            icon="e6-icon-field_line"
            @click="columSetVisible = !columSetVisible"
            plain
          ></el-button>
          <el-button
            v-if="operationSuper.编辑"
            class="g-form-section-search operate__item"
            title="编辑"
            icon="el-icon-plus"
            @click="$router.push('/baseStoreEdit')"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item>
            <e6Select
              :dataList="vehicleTreeList"
              :filterable="true"
              slotTemplate="tree"
              :issingleleaf="true"
              multiple
              ref="vehicleTreeSelect"
              :placeholder="'车牌号'"
            ></e6Select>
          </el-form-item>
          <el-form-item prop="forms.comparyIdList" class="form-item_2">
            <el-select
              v-model="slotForms.forms.comparyIdList"
              multiple
              filterable
              collapse-tags
              reserve-keyword
              placeholder="企业名称"
              :loading="loading"
            >
              <el-option
                v-for="item in comparyList"
                :key="item.comparyId"
                :label="item.comparyName"
                :value="item.comparyId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="forms.regisArea">
            <e6-city
              ref="e6City"
              :placeholder="$GLOBAL_CONFIG.e6City.placeholder"
              class="e6-city"
              @selected="citySelect"
            ></e6-city>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->

    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
      >
        <el-table-column
          label="序号"
          width="80"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in localShowTableCols"
          :key="index"
          :show-overflow-tooltip="true"
          :prop="item.name"
          :label="item.title"
        ></el-table-column>
        <!--<el-table-column align="center" label="操作" width="120">-->
        <!--<template slot-scope="scope">-->
        <!--<router-link-->
        <!--v-if="operationSuper.编辑"-->
        <!--:to="{-->
        <!--path: '/baseStoreEdit',-->
        <!--query: { pageType: '2', id: scope.row.storeId,provinceId:scope.row.provinceId }-->
        <!--}"-->
        <!--&gt;编辑</router-link-->
        <!--&gt;&nbsp;-->
        <!--<el-button v-if="operationSuper.删除" @click="deleteRow(scope)" type="text" size="small"-->
        <!--&gt;删除</el-button-->
        <!--&gt;-->
        <!--</template>-->
        <!--</el-table-column>-->
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->
  </div>
</template>

<script>
import e6City from "e6city";
import {
  FetchGetTableColumnSettings,
  FetchSaveUserTableColumnSettings
} from "_private/api/public.js";
import {
  FetchFindByPage,
  FetchVehicleTree,
  FetchEmergencyComparyName
} from "@/api/base/emergencyVehicle";
import { mapGetters, mapActions } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import operationManage from "_private/mixins/operationManage";
import { mergeFormExtend } from "_private/utils/merge";

export default {
  components: { e6City },
  mixins: [resizeListener, operationManage],
  data() {
    return {
      total: 0,
      isSearch: false,
      vehicleTreeList: [],
      comparyList: [],
      curPage: 1,
      pageSize: 20,
      formExtend: {
        forms: {
          vehicleNum: "",
          vehicleIdList: [],
          comparyId: "",
          comparyIdList: [],
          comparyName: "",
          countyNameId: "",
          // provinceName: $GLOBAL_CONFIG.e6City.provinceName,
          provinceName: "",
          // cityName: $GLOBAL_CONFIG.e6City.cityName,
          cityName: "",
          countyName: ""
        },
        extends: []
      },
      formsExtend: [],
      tableData: [],
      columSetVisible: false,
      showTableCols: [],
      hideTableCols: [],
      copyShowTableCols: [],
      copyHideTableCols: [],
      localShowTableCols: [],
      multipleSelection: [],
      messageBoxVisible: false,
      analysisError: false,
      aErrorDatas: [],
      idList: [],
      errMess: "",
      loading: false,
      isFirstLoad: true,
      //导出URL
      exportUrl: "/base/store/exportStoreInfo?"
    };
  },
  computed: {
    ...mapGetters(["moduleId", "searchFormIsOpen", "userId"]),
    ids() {
      let ids = this.multipleSelection.map(item => {
        return item.id;
      });
      return ids.length < 1 ? "" : ids.join(",");
    },
    columnStr() {
      let columnStr = this.copyShowTableCols.map(item => {
        return item.name;
      });
      return columnStr.length < 1 ? "" : columnStr.join(",");
    },
    vehicleIds() {
      let vehicles = this.$route.query.vehicleIds;
      if (vehicles) {
        return vehicles.split(",");
      } else {
        return [];
      }
    }
  },
  created() {
    this.FetchGetTableColumnSettings({
      moduleId: this.moduleId,
      userId: this.userId
    });
    //初始化区位树
    this.initVehicleTree();
    //初始化应急企业列表下拉
    this.initComparyName();
    this.setSearchFormIsOpenAct();
  },
  mounted() {
    let comparyName = this.$route.query.comparyName;
    if (comparyName) {
      this.formExtend.forms.comparyName = comparyName;
    }

    if (this.vehicleIds.length) {
      this.formExtend.forms.vehicleIdList = this.vehicleIds;
      // this.$refs.vehicleTreeSelect.setSelectList([93, 94]);
    }

    this.FetchFindByPage(this.mergeObj());
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 删除行
    // deleteRow({ row }) {
    //   this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning"
    //   })
    //     .then(async () => {
    //       this.loading = true;

    //       const { code, message } = await DeleteStoreInfoByIds({
    //         ids: row.storeId
    //       });

    //       this.loading = false;

    //       if (code === 1) {
    //         this.successMessage("删除成功", () => {
    //           this.handleCurrentChange(1);
    //         });
    //       } else {
    //         this.errorMessage(message || "删除失败，请重试");
    //       }
    //     })
    //     .catch(() => {
    //       this.$message({
    //         type: "info",
    //         message: "已取消删除"
    //       });
    //     });
    // },

    //初始化区位树
    initVehicleTree() {
      FetchVehicleTree()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.vehicleTreeList = response.result;
            this.$nextTick(() => {
              this.$refs.vehicleTreeSelect.setSelectList(this.vehicleIds);
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //初始化应急企业列表下拉
    initComparyName() {
      FetchEmergencyComparyName()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.comparyList = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    citySelect(res) {
      if (res.province.name == "澳门") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else if (res.province.name == "香港") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else if (res.province.name == "台湾省") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.city.name;
        this.formExtend.forms.countyName = res.district.name;
      }
    },
    // 获取表格数据
    FetchFindByPage(response) {
      this.loading = true;
      FetchFindByPage(response)
        .then(response => {
          if (
            response.result &&
            response.result.data &&
            Array.isArray(response.result.data)
          ) {
            this.tableData = response.result.data;
            this.total = response.result.totalRecords;
          }
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
    // 获取表格列列表
    FetchGetTableColumnSettings(data) {
      FetchGetTableColumnSettings(data)
        .then(response => {
          let data = response;
          let showTableCols = [];
          let hideTableCols = [];
          if (data && data.result && Array.isArray(data.result)) {
            data.result.forEach(item => {
              if (item.show) {
                showTableCols.push(item);
              } else {
                hideTableCols.push(item);
              }
            });
          }
          this.showTableCols = showTableCols;
          this.hideTableCols = hideTableCols;
          this.copyShowTableCols = showTableCols;
          this.copyHideTableCols = hideTableCols;
          this.localShowTableCols = showTableCols;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 修改表格列列表
    FetchSaveUserTableColumnSettings(data) {
      FetchSaveUserTableColumnSettings(data)
        .then(response => {
          let type = response.code === 1 ? "success" : "error";
          let message = response.message;
          this.$message({
            showClose: true,
            message: message,
            type: type,
            duration: 2000,
            onClose: () => {
              if (type === "success") {
                this.FetchGetTableColumnSettings({
                  moduleId: this.moduleId,
                  userId: this.userId
                });
              }
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 整合查询数据
    mergeObj() {
      // let vehicleIdList;
      // if (this.isFirstLoad) {
      //   vehicleIdList = this.idList;
      //   this.isFirstLoad = false;
      // } else {
      //   vehicleIdList = this.getVehicleIdListParam();
      // }
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        // vehicleIdList: vehicleIdList,
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      });
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchFindByPage(this.mergeObj());
    },
    // 重置
    handleResetForm() {
      this.$refs.e6City.cityInputValue = "河南省郑州市";
      this.formExtend.forms.provinceName = "河南省";
      this.formExtend.forms.cityName = "郑州市";
      this.formExtend.forms.countyName = "";
      this.$refs.vehicleTreeSelect.multipleRemoveAll();
      this.formExtend.forms.vehicleIdList = [];
    },
    // 选择表格列
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchFindByPage(this.mergeObj());
    },

    // 取消表格列设置
    handleSetColumnCancel() {
      this.copyShowTableCols = this.showTableCols;
      this.copyHideTableCols = this.hideTableCols;
    },
    // 确认表格列设置
    handleSetColumnSubmit() {
      this.FetchSaveUserTableColumnSettings({
        moduleId: this.moduleId,
        userId: this.userId,
        columnStr: this.columnStr
      });
    },
    //获取选中区位id
    getVehicleIdListParam() {
      let selected = this.$refs.vehicleTreeSelect.getSelectValues();
      selected = selected.map(item => {
        return item.id;
      });
      return selected;
    },

    handleExportClick() {
      let vehicleIdList;
      if (this.isFirstLoad) {
        vehicleIdList = this.idList;
        this.isFirstLoad = false;
      } else {
        vehicleIdList = this.getVehicleIdListParam();
      }
      let param = "";
      param += "&comparyName=" + this.formExtend.forms.comparyName;
      param += "&storeName=" + this.formExtend.forms.storeName;
      param += "&countyNameId=" + this.formExtend.forms.countyNameId;
      param += "&provinceName=" + this.formExtend.forms.provinceName;
      param += "&cityName=" + this.formExtend.forms.cityName;
      param += "&countyName=" + this.formExtend.forms.countyName;
      param += "&vehicleIdList=" + vehicleIdList;
      document.location.href = this.exportUrl + param;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.form-item_2 {
  width: 200px;

  /deep/ .el-form-item--mini .el-form-item__content {
    width: 200px;
  }

  /deep/ .el-select {
    width: 200px;

    .el-select__tags {
      max-width: 195px !important;
    }

    .el-select__tags-text {
      display: inline-block;
      max-width: 90px;
      text-overflow: ellipsis;
      overflow: hidden;
      vertical-align: middle;
    }
  }
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}
</style>
